import { Deal } from '../gql/dealGql';
import { TemporaryData } from '../gql/generated/graphql';
import { LienholderPRSType, PayoffMethods } from '../gql/prs/types';

import { Option } from '../components/shared/types';

import { isDeal } from './deals';

export const getPayoffMethods = (payoffMethodOptions: PayoffMethods) =>
  Object.entries(payoffMethodOptions)
    .map(([key, value]) => ({
      key,
      value: typeof value === 'string' ? value : value.value,
      options: typeof value === 'string' ? undefined : value.options,
    }))
    .filter(({ key, value }) => key !== '__typename' && key !== 'id' && value !== 'FALSE');

export const getLienholderPhoneNumbers = (
  phoneNumbers: [
    {
      name: string;
      phone_numbers: [string];
    },
  ],
) => phoneNumbers?.flatMap((numbers) => numbers.phone_numbers);

export const getLienholderQueryVariables = (data: Deal | TemporaryData) => {
  if (isDeal(data)) {
    return {
      state: data.customer?.address?.state,
      slug: data.car?.payoff?.lienholder_slug,
    };
  }

  return {
    state: data?.state ?? '',
    slug: data?.lienholder_slug,
  };
};

export const mapPRSLienholdersToOptions = (lienholders: LienholderPRSType[]): Option[] =>
  lienholders.map((lienholder) => ({
    label: lienholder.display_name,
    value: lienholder.slug,
    enabled: lienholder.enabled,
    is_core: lienholder.is_core,
  }));
